import { Injectable } from '@angular/core';
import { HeaderSearchIntl } from '@knorr-bremse-portals/ngx-components/components/header';

@Injectable({providedIn: 'root'})
export class LocalHeaderSearchIntl extends HeaderSearchIntl {

  public override searchInputLabel = $localize `:header search input label@@4580988005648117665:Search`;
  public override searchSubmitLabel = $localize `:header search submit label@@4548392842898432989:Search`;
  public override openSearchButtonLabel = $localize `:header search open button label@@5802965435902234763:Open search`;
  public override closeSearchButtonLabel = $localize `:header search close button label@@6853170548960328665:Close search`;

}
